const translations = {
  "en": {
    "Transcribing....": "Transcribing...."
  },
  "zh-tw": {
    "Transcribing....": "輸入中...."
  }
};

export default translations;
